<template>
  <div class="contract-information-page pb60" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="开票审批申请"></Title>
    <!-- 开票说明 -->
    <div class="contract-base-box title-box">
      <p class="contract-base-name">需开票的付款通知书信息</p>
      <div class="back-color-fff content-main-box" style="height: 100%">
        <el-table :data="tableData" stripe border style="width: 100%" max-height="50vh">
          <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="flowName"
            label="流程名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="180"
            fixed="left"
          >
            <template slot-scope="scope">{{ scope.row.flowName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="发起人"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="100"
          >
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizTenantName"
            label="药企名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="180"
          >
            <template slot-scope="scope">{{ scope.row.bizTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizOrganisationName"
            label="组织名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="180"
          >
            <template slot-scope="scope">{{ scope.row.bizOrganisationName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="accountMonthName"
            label="核算月"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="100"
          >
            <template slot-scope="scope">{{ scope.row.accountMonthName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="任务金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
          >
            <template slot-scope="scope">{{ scope.row.taskSumAmount | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="serviceFeeRate"
            label="服务费率"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="100"
          >
            <template slot-scope="scope">{{ (scope.row.serviceFeeRate || 0) + '%' }}</template>
          </el-table-column>
          <el-table-column
            prop="serviceFee"
            label="服务费(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
          >
            <template slot-scope="scope">{{ scope.row.serviceFee | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="currentPayAmount"
            label="应付金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
          >
            <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="审批通过时间"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="140"
          >
            <template slot-scope="scope">{{ scope.row.approveTime | getTime }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="total_money_wrap">
        <div class="total-money-list">
          <span class="total-money-title"
            ><el-popover
              placement="top-start"
              content="任务金额与应付金额有误差一是合同是否含税，二是药企考核后会对应付金额有影响"
              trigger="hover"
            >
              <i slot="reference" class="el-icon-question"></i> </el-popover
            >应付金额：</span
          ><span class="total-money-num"> {{ formData.invoiceAmount | numFmt | numDigit }}</span
          >元
        </div>
        <div class="total-money-list">
          <span class="total-money-title">服务费：</span
          ><span class="total-money-num"> {{ formData.serviceFee | numFmt | numDigit }}</span
          >元
        </div>
        <div class="total-money-list">
          <span class="total-money-title">任务金额：</span
          ><span class="total-money-num"> {{ formData.taskSumAmount | numFmt | numDigit }}</span
          >元
        </div>
      </div>
    </div>
    <!-- 开票说明 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票说明</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票金额（元）：</div>
          <el-input
            disabled
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            v-model.trim="formData.invoiceAmount"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票主体：</div>
          <el-select
            disabled
            filterable
            v-model="formData.servicerTenantGuid"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票类型：</div>
          <el-select v-model="formData.invoiceOptions" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('发票选项')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>药企名称：</div>
          <el-select
            filterable
            v-model="formData.tenantGuid"
            @change="tenantChange"
            class="contract-base-content"
            placeholder="请选择"
            @focus="tenantFocus(1)"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>组织名称：</div>
          <el-select
            filterable
            v-model="formData.organisationGuid"
            @change="organisationChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in organisationList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票日期：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="formData.invoiceDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择"
          >
          </el-date-picker>
        </el-col>
        <!-- <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票类目：</div>
          <el-select v-model="formData.invoiceCategory" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('发票类目')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>预计回款日期：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="formData.planRepayDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
      
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否回款：</div>
          <el-select
            @change="formData.receivePaymentGuidList = []"
            v-model="formData.isReceivePayment"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12" v-if="formData.isReceivePayment == 'Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>关联上游收款：</div>
          <el-select
            multiple
            filterable
            v-model="formData.receivePaymentGuidList"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in isApplyInvoiceTableData" :key="item.guid" :label="item.label" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否邮寄：</div>
          <el-select v-model="formData.isMail" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
           <!-- 邮寄地址 新增字段 -->
           <el-col :span="24" v-if="formData.isMail=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>邮寄地址：</div>
          <el-input
            v-model.trim="formData.mailAddress"
            class="contract-base-content"
            placeholder="请输入"
            clearable
            maxlength="50"
            :rows="3"
            type="textarea"
            resize="none"
            style="width:100%;max-width: calc(50% + 324px)!important;"
 
          ></el-input>
        </el-col>
        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red"> </span>简述或备注：</div>
          <el-input
            v-model.trim="formData.remarks"
            class="contract-base-content"
            placeholder="请输入"
            clearable
            maxlength="100"
            :rows="3"
            type="textarea"
            resize="none"
            style="width:100%;max-width: calc(50% + 324px)!important;"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <!-- 开票信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票信息</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票抬头：</div>
          <el-input
            disabled
            v-model.trim="formData.invoiceTenantName"
            class="contract-base-content"
            :maxlength="30"
            placeholder="不可修改，请选择开户银行"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合计金额(元)：</div>
          <el-input
            disabled
            v-model.trim="formData.invoiceAmount"
            class="contract-base-content"
            :maxlength="30"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
             <!-- 发票类目 start -->
        <div class="invoice-category" v-for="(item, index) in formData.invoiceApplyDetailList" :key="index">
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>发票类目{{index+1}}：</div>
            <el-select v-model="item.invoiceCategory" class="contract-base-content" placeholder="请选择">
              <el-option
                v-for="item in getCodeListByKey('发票类目')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>金额(元)：</div>
            <el-input
              v-model.trim="item.invoiceAmount"
              class="contract-base-content"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="12"
              placeholder="请输入"
              clearable
            ></el-input>
            <div class="invoice-category-btns">
              <div class="add"  @click="addInvoiceCategory">添加类目</div>
              <div class="del" v-if="index!=0" @click="delInvoiceCategory(index)">删除</div>
            </div>
          </el-col>
        </div>
        <!--发票类目 end  -->
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开户银行：</div>
          <el-select
            filterable
            v-model="formData.contractBankGuid"
            @change="bankChange"
            class="contract-base-content"
            placeholder="请选择"
            @focus="tenantFocus(2)"
          >
          <el-option v-for="item in bankList" :key="item.guid" :label="item.bankName" :value="item.guid"> 
              <span style="float: left">{{ `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType,'账户类型')}` }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>税号：</div>
          <el-input
            disabled
            v-model.trim="formData.taxpayerId"
            class="contract-base-content"
            oninput="if(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/.test(value)) value=value.replace(/\D/g,'')"
            :maxlength="20"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>银行账号：</div>
          <el-input
            disabled
            v-model.trim="formData.bankAccount"
            class="contract-base-content"
            :maxlength="15"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>电话号码：</div>
          <el-input
            v-model.trim="formData.contactTel"
            @input="form.contactsMobile = form.contactsMobile.replace(/[^\d\-\d]/g, '')"
            class="contract-base-content"
            :maxlength="20"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>

        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>单位地址：</div>
          <el-input
            type="textarea"
            v-model.trim="formData.address"
            class="contract-base-content"
            :maxlength="50"
            placeholder="请输入"
            clearable
            resize="none"
            style="width:100%;max-width: calc(50% + 324px)!important;"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderGreen" size="small" @click="saveReq(0)" v-if="$route.query.toType !== '3'">保存</el-button>
      <el-button type="importNew" size="small" @click="saveReq(1)">提交申请</el-button>
    </div>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import { bpmnroute } from '@/api/apiRoute';
import store from '@/store';
import Title from '@/components/title/title.vue';
import Decimal from "decimal"
console.log(Decimal)
export default {
  components: {
    Title,
  },
  data() {
    return {
      flowType: '00018',
      fullscreenLoading: false,
      tenantList: [], //药企
      serviceTenantList: [], //服务商
      organisationList: [], //组织
      tableData: [],
      bankList: [],
      tableLoading: false,
      // 表单内容
      formData: {
        guid: null,
        invoiceAmount: null, //开票金额
        servicerTenantGuid: null, //服务商唯一标识，开票主体
        servicerTenantName: null, //服务商名称
        invoiceOptions: null, //发票类型
        tenantGuid: null, //药企唯一标识
        tenantName: null, //药企名称
        organisationGuid: null, //组织唯一标识
        organisationName: null, //组织名称
        month: null, //月份
        planRepayDate: null, //预计回款日期
        remarks: null, //简述或备注
        taxpayerId: null, //税号
        contactTel: null, //电话号码
        contractBankGuid: null, //合同开户行唯一标识
        bankName: null, //开户银行
        bankAccount: null, //银行账号
        address: null, //单位地址
        bizApproveState: null, //业务审批状态
        currentTenantGuid: null, //当前登录人的公司唯一标识
        isSendFlowFlag: null, //是否发起流程
        isMail: null, //是否邮寄，Y 是；N 否
        isReceivePayment: null, //是否回款，Y 是；N 否
        receivePaymentGuidList: [], //付款通知单唯一标识
        paymentTicketGuidList: [], //上游收款信息唯一标识
        mailAddress:null,//邮寄地址
        invoiceDate:null,//开票日期
        invoiceTenantName:null,//发票抬头
        invoiceApplyDetailList:[{invoiceCategory:null,invoiceAmount:null}],//发票类目

      },
      isApplyInvoiceTableData: [],
      //流程
      srcs: '', //流程地址
      processInstanceId: '', //流程id
      iframeSh: false, //流程显示
      trueOrFalseOption: [
        { text: '是', value: 'Y' },
        { text: '否', value: 'N' },
      ],
    };
  },
  created() {
    this.getFlowGuid();
    if (this.$route.query.guid) {
      this.getPageDetail();
    }
    this.getServiceTenantList();
  },
  methods: {
    //新增发票类目
    addInvoiceCategory(){
      this.formData.invoiceApplyDetailList.push({
        invoiceCategory:null,
        invoiceAmount:null
      })
    },
     //删除发票类目
    delInvoiceCategory(index){
      this.formData.invoiceApplyDetailList.splice(index,1)
    },
    //获取服务商
    getServiceTenantList() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data || [];
          this.serviceTenantList.forEach((i) => {
            if (i.guid == localStorage.guid) {
              this.formData.servicerTenantName = i.tenantName;
            }
          });
          // self.servicerTenantChange(self.formData.servicerTenantGuid || localStorage.guid);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // servicerTenantChange(val) {
    // if (val) {
    //   this.serviceTenantList.forEach((i) => {
    //     if (i.guid == val) {
    //       this.formData.servicerTenantName = i.tenantName;
    //     }
    //   });
    //   this.formData.tenantName = null;
    //   this.formData.tenantGuid = null;
    //   this.getTenantList(val);
    // }
    // },
    //获取药企
    getTenantList(val) {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 药企变化时清空其他信息
    tenantChange(val) {
      if (val) {
        this.tenantList.forEach((i) => {
          if (i.sendTenantGuid == val) {
            this.formData.tenantName = i.sendTenantName;
          }
        });
        this.getOrganisationList(val);
        this.getBankList(val);
        this.getInvoiceItem();
        this.formData.organisationName = null;
        this.formData.organisationGuid = null;
        this.formData.bankName = null;
        this.formData.contractBankGuid = null;
        this.formData.bankAccount = null;
        this.formData.taxpayerId = null;
        this.formData.address = null;
        this.formData.contactTel = null;
      }
    },
    //药企选择判断
    tenantFocus(type) {
      if (!this.formData.servicerTenantGuid) {
        this.$message.error('请先选择开票主体');
      }
      if (type == 2 && !this.formData.tenantGuid) {
        this.$message.error('请先选择药企');
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/get-organisation-dict?tenantGuid=${v}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //组织变化赋值
    organisationChange(val) {
      if (val) {
        this.organisationList.forEach((i) => {
          if (i.value == val) {
            this.formData.organisationName = i.text;
          }
        });
      }
    },
    //获取开户银行
    getBankList(val) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/get-tenant-invoice-list?tenantGuid=${val}&bizState=Y`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.bankList = res.data.data || [];
            // self.bankList.forEach(item => {
            //   item.bankNameLabel = item.bankName + ' _ ' + item.bankAccount + ' _ ' + this.getName(item.accountType, '账户类型');
            // })
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach(item => {
          list.forEach(el => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          })
        })
        return newArr.length ? newArr.join('、') : '-';

      } else {
        let lisArr = list.filter(item => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }
    },
    //银行变化赋值
    bankChange(val) {
      if (val) {
        this.bankList.forEach((i) => {
          if (i.guid == val) {
            this.formData.bankName = i.bankName;
            this.formData.bankAccount = i.bankAccount;
            this.formData.taxpayerId = i.taxpayerId;
            this.formData.address = i.address;
            this.formData.contactTel = i.tel;
            this.formData.invoiceTenantName = i.tenantName;
          }
        });
      }
    },
    //获取上游数据
    getInvoiceItem(val) {
      let self = this;
      let query = {
        streamType: '1',
        payTenantGuid: self.formData.tenantGuid,
        receiveTenantGuid: localStorage.guid,
        isQueryChild:"Y"
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/get-select-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.isApplyInvoiceTableData = res.data.data || [];
          if (self.isApplyInvoiceTableData.length > 0) {
            self.isApplyInvoiceTableData.forEach((i) => {
              i.label =
                self.$moment(i.receiveDate).format('YYYY-MM-DD') +
                '收款' +
                this.formatMoney(i.receiveAmount || 0) +
                '元';
            });
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msSalesPerformService}/upstream/payment-invoice-apply/detail?guid=${this.$route.query.guid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            this.getFormData(2, data);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //页面信息
    getFormData(type, data) {
      this.formData = {
        guid: type == 1 ? null : data.guid,
        invoiceAmount: data.invoiceAmount.toFixed(2),
        servicerTenantGuid: data.servicerTenantGuid || localStorage.guid,
        servicerTenantName: data.servicerTenantName || this.formData.servicerTenantName,
        invoiceOptions: data.invoiceOptions,
        tenantGuid: data.tenantGuid,
        tenantName: data.tenantName,
        organisationGuid: data.organisationGuid,
        organisationName: data.organisationName,
        month: data.month ? data.month.substr(0, 4) + '-' + data.month.substr(4, 2) : null,
        invoiceApplyDetailList: data.invoiceApplyDetailList||[{invoiceCategory:null,invoiceAmount:null}],
        planRepayDate: data.planRepayDate ? this.$moment(data.planRepayDate).format('YYYY-MM-DD') : null,
        remarks: data.remarks,
        taxpayerId: data.taxpayerId,
        contactTel: data.contactTel,
        contractBankGuid: data.contractBankGuid,
        bankName: data.bankName,
        bankAccount: data.bankAccount,
        address: data.address,
        bizApproveState: data.bizApproveState,
        currentTenantGuid: data.currentTenantGuid,
        isSendFlowFlag: data.isSendFlowFlag,
        serviceFee: data.serviceFee,
        taskSumAmount: data.taskSumAmount,
        isMail: data.isMail,
        mailAddress: data.mailAddress,
        isReceivePayment: data.isReceivePayment,
        receivePaymentGuidList: data.receivePaymentGuidList || [],
        paymentTicketGuidList: data.paymentTicketGuidList || [],
        invoiceDate:data.invoiceDate,
        invoiceTenantName:data.invoiceTenantName

      };
      this.tableData = data.paymentTicketList;
      this.getTenantList(data.servicerTenantGuid);
      this.getOrganisationList(data.tenantGuid);
      this.getBankList(data.tenantGuid);
      this.getInvoiceItem();
    },
    // 页面数据必填校验
    checkForm() {
      if (!this.formData.servicerTenantGuid) {
        this.$message.error('开票主体不能为空');
        return false;
      }
      if (!this.formData.invoiceOptions) {
        this.$message.error('发票类型不能为空');
        return false;
      }
      if (!this.formData.tenantGuid) {
        this.$message.error('药企名称不能为空');
        return false;
      }
      if (!this.formData.organisationGuid) {
        this.$message.error('组织名称不能为空');
        return false;
      }
      if (!this.formData.invoiceDate) {
        this.$message.error('开票日期不能为空');
        return false;
      }
      // if (!this.formData.invoiceCategory) {
      //   this.$message.error('发票类目不能为空');
      //   return false;
      // }
      if (!this.formData.planRepayDate) {
        this.$message.error('预计回款日期不能为空');
        return false;
      }

   
      if (!this.formData.isReceivePayment) {
        this.$message.error('是否回款不能为空');
        return false;
      }
      if (!this.formData.isMail) {
        this.$message.error('是否邮寄不能为空');
        return false;
      }
      if (this.formData.isMail=='Y'&&!this.formData.mailAddress) {
        this.$message.error('邮寄地址不能为空');
        return false;
      }
      if (this.formData.isReceivePayment == 'Y' && !this.formData.receivePaymentGuidList.length) {
        this.$message.error('关联上游收款不能为空');
        return false;
      }
      // if (!this.formData.remarks) {
      //   this.$message.error('简述或备注不能为空');
      //   return false;
      // }
      if (!this.formData.invoiceTenantName) {
        this.$message.error('发票抬头不能为空');
        return false;
      }

      try {
        this.formData.invoiceApplyDetailList.forEach((item, index) => {
          if (!item.invoiceCategory) {
            throw new Error(`发票类目${index + 1}不能为空`)
          }
          if (!item.invoiceAmount) {
            throw new Error('金额不能为空')
          }
        })
      } catch (error) {
        this.$message.error(error.message);
        return false
      }
      let invoiceAmount = 0;
      this.formData.invoiceApplyDetailList.forEach(item => {
        invoiceAmount = Decimal(invoiceAmount).add(item.invoiceAmount);
      })
   
      if (invoiceAmount !=  Number(this.formData.invoiceAmount)) {
        this.$message.error('发票类目金额之和与合计金额必须相等');
        return false;
      }
      if (!this.formData.bankName) {
        this.$message.error('开户银行不能为空');
        return false;
      }
      return true;
    },
    //提交申请 type为1时保存否则提交
    saveReq(type) {
      if (type == 1 && !this.checkForm()) {
        return;
      } else if (!this.formData.servicerTenantGuid) {
        this.$message.error('开票主体不能为空');
        return false;
      }
      //当前登录人信息
      let userinfo = JSON.parse(localStorage.userInfo);
      let form = this.formData;
      form.staffGuid = userinfo.staffGuid;
      form.staffName = userinfo.staffName;
      //是否发起流程
      form.isSendFlowFlag = type == 1 ? 'Y' : 'N';
      if (this.$route.query.toType == 3) {
        //重新提交
        form.bizApproveState = 'D';
      }
      this.fullscreenLoading = true;
      form.currentTenantGuid = localStorage.guid;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/upstream/payment-invoice-apply/update`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '提交成功',
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
            } else {
              self.$message.error('未获取到流程信息');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
.contract-base-box .el-col-12,
.contract-base-box .el-col-24,
.contract-base-box .el-col-7,
.contract-base-box .el-col-6 {
  min-height: 37px;
  display: flex;
  /* align-items: center; */
  margin-bottom: 8px;
  padding-right: 20px;
  box-sizing: border-box;
}
.contract-base-title {
  flex-shrink: 0;
  width: 140px;
  line-height: 36px;
  text-align: right;
  font-size: 14px;
}
.contract-base-content {
  width: 314px;
  text-align: left;
  line-height: 36px;
}
/deep/.el-radio-group {
  padding-top: 5px !important;
}
/* 添加银行 */
.add-bank-box {
  color: #4fa1a4;
  margin-left: 15px;
  line-height: 36px;
}
.add-bank-box span {
  cursor: pointer;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.title-box {
  padding-bottom: 0 !important;
}
.invoice-category-btns{
  display: flex;
  align-items: center;
  color: #4fa1a4;
  cursor: pointer;
}
.invoice-category-btns .add{
  margin: 0 10px;
}
</style>
